import classNames from 'classnames';
import { UserName } from 'features/UserCard';
import { TimesheetTableRow } from '../../TimesheetsTable.types';

import styles from './EntityNameCell.module.scss';

export const EntityNameCell: React.FC<{ record: TimesheetTableRow }> = ({ record }) => {
  if ('employeeName' in record) {
    return (
      <span className={classNames(styles.ellipsisName, styles.userNameBlock)}>
        <UserName name={record.employeeName} id={record.employeeId} />
      </span>
    );
  }
  if ('projectName' in record)
    return <span className={classNames(styles.ellipsisName, styles.boldText)}>{record.projectName}</span>;
  if ('accountName' in record)
    return <span className={classNames(styles.ellipsisName, styles.boldText)}>{record.accountName}</span>;
  return null;
};
